<ng-container *transloco="let t; read: 'formFieldSchedule'" [formGroup]="parentFormGroup">
  <mat-form-field class="form-field">
    <crm-schedule-mat-input
      [placeholder]="field.name"
      [formControlName]="field.key"
      [minutesStep]="minutesStep"
      [required]="parentFormGroup.get(field.key).errors?.required"
      [teacherSelectionUnavailableSlots]="teacherSelectionUnavailableSlots"
    ></crm-schedule-mat-input>

    <mat-error [ngxErrors]="field.key" #error="ngxErrors">
      <span ngxError="required">{{ t('requiredField') }}</span>
      <span ngxError="minlength">
        {{ t('minlength', { minlength: error.getError('minlength')?.requiredLength }) }}
      </span>
      <span ngxError="backend">{{ error.getError('backend') }}</span>
    </mat-error>
  </mat-form-field>
</ng-container>
